import { SvgMenuButton } from "../../assets/svg";
import { StorageAuth } from "../../core/localStorage";
import { ActionUI, useAppDispatch, useAppSelector } from "../../core/redux";
import { useAuthFunc } from "../../libs/hooks";
import { AppRouteApi, AppRouteUi } from "../../config/appRoute";
import { useHistory } from "react-router-dom";
import { useState } from "react";

const DropdownTitle = () => {
  const { firstName, lastName, userRole } = useAppSelector(
    (state) => state.auth
  );
  const { ProfilePic } = StorageAuth;
  const [menuVisible, setMenuVisible] = useState(false);

  const { isBusy, logOut } = useAuthFunc();
  const history = useHistory();
  const redirectToSettings = () => history.push(AppRouteUi.Settings.Root());

  return (
    <div className="profile-image">
      <img
        src={
          ProfilePic
            ? AppRouteApi.Media.ByPath(ProfilePic)
            : "/img/admin-profile.svg"
        }
        alt=""
        width={35}
        height={35}
        className="rounded-circle object-fit-cover my-2 click"
        onClick={() => setMenuVisible(!menuVisible)}
      />

      <div
        className={`navbar-dropdown-menu ${!menuVisible && "hidden"}`}
        onClick={() => setMenuVisible(false)}
      />

      <div
        className={`rounded shadow-lg navbar-dropdown-menu-item ${
          !menuVisible && "hidden"
        }`}
      >
        <div className="p-3">
          {firstName} {lastName}
          <p className="small-text">{userRole}</p>
        </div>

        <hr className="m-0" />

        <div className="p-3">
          <p
            className="click"
            onClick={() => {
              setMenuVisible(false);
              redirectToSettings();
            }}
          >
            Settings
          </p>
          <p
            className="click"
            onClick={() => {
              setMenuVisible(false);
              !isBusy && logOut();
            }}
          >
            Log Out
          </p>
        </div>
      </div>
    </div>
  );
};

export const Nav = () => {
  const companyName = StorageAuth.CompanyName;
  const dispatch = useAppDispatch();
  return (
    <header className="site-header d-flex justify-content-between align-items-center">
      <button
        className="site-nav-toggle btn btn-link site-btn-link "
        onClick={(_) => dispatch(ActionUI.openSideNav())}
      >
        <SvgMenuButton />
      </button>
      <h5 className="px-3 text-green-200">{companyName}</h5>
      <div className="d-flex justify-content-between align-items-center profile-pic">
        <div className="right-header-content">
          <div className="d-flex align-items-center">
            <DropdownTitle />
          </div>
        </div>
      </div>
    </header>
  );
};
